import * as Sentry from "@sentry/react";

type CaptureExceptionOptions = {
  tags?: Record<string, string>;
  contexts?: Record<string, Record<string, unknown>>;
};

export const captureSentryException = (
  error: unknown,
  options?: CaptureExceptionOptions,
) => {
  Sentry.captureException(error, {
    tags: options?.tags,
    contexts: options?.contexts,
  });
};
